const NS = 'CourseAssessmentSectionNavigatorWidget';
const CLS = 'courseAssessmentSectionNavigatorWidget';

let _isInteger = require('lodash/isInteger');

import { scrollIntoView } from 'scroll-js';

export class CourseAssessmentSectionNavigatorWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$tplScroller = $('.tpl-scroller');

		this.$navigation = this.$element.find(`.${CLS}-navigation`);
		this.activeNavigationSectionIndex = _.isFinite(+this.$element.attr('data-active-section-index')) ? +this.$element.attr('data-active-section-index') : 0;
		this.$activeNavigationSection; // Subset of navigation items that is displayed
		this.scrollDuration = 750;
		this.scrollEasing = 'ease-in-out';
		this.$navigationActiveItem;

		this.createNavigator();
		this.setScrollEvent();

		this.$element.on(`${CLS}.activeNavigationSectionIndex.changed`, (event, params) => {
			if(_isInteger(params.activeNavigationSectionIndex)) {
				if(this.activeNavigationSectionIndex !== params.activeNavigationSectionIndex) {
					this.removeActiveSection(params.activeNavigationSectionIndex);
					this.setActiveSection(params.activeNavigationSectionIndex);
				}
			}
			else {
				console.error(`${NS}::Error`, `Please supply a valid sectionIndex. The value ${params.activeNavigationSectionIndex} is invalid`);
			}
		});
	}

	createNavigator() {
		this.$sections = $('[data-pg]').first().find('.Form__Element.FormStep');

		if(this.$sections && this.$sections.length > 0) {
			let blocksIndex = 0; // Count of all the total blocks
			this.$sections.each((sectionIndex, sectionElement) => {
				let $blocks = $(sectionElement).children('.FormChoice').children('[class*="Block"]');
				let templateString = `<div class="${CLS}-navigation-section" data-section-index="${sectionIndex}">`;

				if($blocks && $blocks.length > 0) {
					$blocks.each((_blockIndex, blockElement) => {
						$(blockElement).addClass(`section section--${blocksIndex}`);
						templateString += `<a id="${CLS}-navigation-item--${blocksIndex}" class="${CLS}-navigation-item ${CLS}-navigation-item--${blocksIndex}" href="javascript:void(0);" data-block-target=".section--${blocksIndex}">${blocksIndex + 1}</a>`;
						blocksIndex++;
					});
				}

				templateString += '</div>';
				this.$navigation.append(templateString);

				if(sectionIndex === this.activeNavigationSectionIndex) {
					this.setActiveSection(sectionIndex);
				}
			});
		}

		this.$element.css({
			position: 'fixed',
			top: '50%',
			left: '30px',
			transform: 'translateY(-50%)',
			visibility: 'visible'
		});

		this.$navigation.find(`a.${CLS}-navigation-item`).on('click', (event) => {
			let section = $($(event.target).attr('data-block-target'))[0];
			scrollIntoView(section, this.$tplScroller[0], { duration: this.scrollDuration, easing: this.scrollEasing });
		});
	}

	removeActiveSection() {
		if(this.$activeNavigationSection && this.$activeNavigationSection.length > 0) {
			this.$activeNavigationSection.removeClass('active');
			this.activeNavigationSectionIndex = null;
			this.$element.attr('data-active-section-index', null);
		}
	}

	setActiveSection(sectionIndex) {
		let $navigationSection = this.$navigation.find(`[data-section-index="${sectionIndex}"]`);

		if($navigationSection && $navigationSection.length > 0) {
			this.$activeNavigationSection = $navigationSection;
			this.$activeNavigationSection.addClass('active');
			this.activeNavigationSectionIndex = sectionIndex;
			this.$element.attr('data-active-section-index', sectionIndex);

			if(this.$navigationActiveItem) {
				this.$navigationActiveItem.removeClass(`${CLS}-navigation-item--active`);
				this.$navigationActiveItem = null;
			}
		}
	}

	setScrollEvent() {
		this.$tplScroller.on('scroll', _.throttle(() => {
			this.setActiveNavigationItem();
		}, 250));
	}

	setActiveNavigationItem() {
		let blocksIndex = 0; // Count of all the elapsed blocks (incremeneted per section)
		this.$sections.each((sectionIndex, sectionElement) => {
			let $blocks = $(sectionElement).children('.FormChoice').children('[class*="Block"]');

			if($blocks) {
				if($blocks.length > 0) {
					if(sectionIndex === this.activeNavigationSectionIndex) {
						$blocks.each((blockIndex, blockElement) => {
							if(0 >= Math.floor($(blockElement).position().top)) {
								let navigationItem = this.$navigation.find(`#${CLS}-navigation-item--${blocksIndex + blockIndex}`);

								if(this.$navigationActiveItem) {
									this.$navigationActiveItem.removeClass(`${CLS}-navigation-item--active`);
								}

								if(this.$navigationActiveItem !== navigationItem) {
									this.$navigationActiveItem = navigationItem;
									this.$navigationActiveItem.addClass(`${CLS}-navigation-item--active`);
								}
							}
						});

						if(!this.$navigationActiveItem) {
							if(this.$activeNavigationSection.find(`.${CLS}-navigation-item`).length > 0) {
								this.$navigationActiveItem = this.$navigation.find(`#${CLS}-navigation-item--${blocksIndex}`);
								this.$navigationActiveItem.addClass(`${CLS}-navigation-item--active`);
							}
						}
					}
					blocksIndex += $blocks.length;
				}
			}
		});
	}
}
